export default __webpack_public_path__ + "static/media/cloudy-nature-2.583fb8f8.jpg";